// Import your dependencies in proper order
import "./lib/jquery.js";
import "./lib/slick.js";
import "./lib/moment.js";
import "./lib/jquery.easing.min.js";
// import "./lib/magnific-popup.js";
import "./lib/validator.js";
import "./lib/wow.js"; 

// Import your scripts
import "./scripts/header";
import "./scripts/nav";
import "./scripts/accessibility";  
import "./scripts/slick";  

// Initialize global functionality
$(document).ready(function () {
	// jQuery check
	if (typeof jQuery !== "undefined") {
		console.log("jQuery is loaded:", jQuery.fn.jquery);

		// Slick check
		if (typeof jQuery.fn.slick === "function") {
			console.log("Slick is loaded");
		} else {
			console.error("Slick is not loaded properly");
		}
	} else {
		console.error("jQuery is not loaded");
	}

	// Initialize AOS safely
	if (typeof AOS !== "undefined") {
		AOS.init({
			duration: 4000,
			easing: "ease-in-out",
			once: true,
			mirror: false,
			disable: window.innerWidth < 768,
		});
		console.log("AOS initialized");
	} else {
		console.error("AOS is not loaded");
	}
});
